import { useMemo } from 'react'
import {  parseARDate, toNumberSafe } from '../utils/formatDate'
import { normalizeText } from '../utils/stringsUtils'

export const usePaginate = (list = [], currentPage = 1, itemsPerPage = 10) => {
	const totalPages = Math.max(1, Math.ceil(list.length / itemsPerPage))
	const safePage = Math.min(Math.max(currentPage, 1), totalPages)
	const startIndex = (safePage - 1) * itemsPerPage
	const endIndex = startIndex + itemsPerPage
	const paginatedResults = list.slice(startIndex, endIndex)

	return { totalPages, paginatedResults, page: safePage }
}

export const useFilteredLabResults = (items, filters) => {
	return useMemo(() => {
		let results = [...items]

		if (filters?.clinic) {
			results = results.filter(item => String(item.idClinic) === String(filters.clinic))
		}

		if (filters?.order) {
			results = results.filter(item => item.orden.includes(filters.order))
		}

		if (filters?.date) {
			results = results.filter(item => item.fecha === filters.date)
		}

		if (filters?.sortBy === 'clinica') {
			results.sort((a, b) => {
				const ca = normalizeText(a.clinica)
				const cb = normalizeText(b.clinica)
				const cmp = ca.localeCompare(cb, 'es', { sensitivity: 'base' })
				return cmp !== 0 ? cmp : a.id - b.id
			})
		}

		if (filters?.sortBy === 'numeroOrden') {
			results.sort((a, b) => {
				const diff = toNumberSafe(a.orden) - toNumberSafe(b.orden)
				return diff !== 0 ? diff : a.id - b.id
			})
		}

		if (filters?.sortBy === 'fechaInforme') {
			results.sort((a, b) => {
				const da = parseARDate(a.fecha)
				const db = parseARDate(b.fecha)

				const ta = da ? da.getTime() : 0
				const tb = db ? db.getTime() : 0

				const diff = tb - ta
				return diff !== 0 ? diff : a.id - b.id
			})
		}

		return results
	}, [items, filters])
}
